import { useNavigate } from 'react-router-dom';
import { Shell } from '../layout/Shell.js';
import { useSession } from '../state/session.js';
import { logout } from '../api/auth.js';

export function AccountPage() {
  const navigate = useNavigate();
  const user = useSession((s) => s.user);
  const refreshToken = useSession((s) => s.refreshToken);
  const clear = useSession((s) => s.clear);

  const onSignOut = async () => {
    if (refreshToken) {
      try {
        await logout(refreshToken);
      } catch {
        /* token already invalid; clear locally regardless */
      }
    }
    clear();
    navigate('/login', { replace: true });
  };

  return (
    <Shell>
      <div className="px-4 pt-[max(env(safe-area-inset-top),16px)]">
        <h1 className="font-display text-2xl font-bold">Account</h1>

        {user ? (
          <section className="card mt-4 p-4">
            <p className="font-display text-lg font-semibold">{user.name}</p>
            <p className="text-sm text-muted">{user.email}</p>
            <p className="num text-sm text-muted">{user.phone}</p>
          </section>
        ) : null}

        <section className="mt-6 space-y-2">
          <h2 className="text-xs font-semibold uppercase tracking-wide text-muted">Settings</h2>
          <div className="card divide-y divide-line">
            <button type="button" className="flex w-full items-center justify-between px-4 py-3 text-left text-sm">
              Saved places
              <span className="text-muted">Coming soon</span>
            </button>
            <button type="button" className="flex w-full items-center justify-between px-4 py-3 text-left text-sm">
              Payment methods
              <span className="text-muted">Cash · Card</span>
            </button>
            <button type="button" className="flex w-full items-center justify-between px-4 py-3 text-left text-sm">
              Help
              <span className="text-muted">support@raahi.test</span>
            </button>
          </div>
        </section>

        <button type="button" onClick={onSignOut} className="btn-ghost mt-6 w-full text-red-600">
          Sign out
        </button>
      </div>
    </Shell>
  );
}
